// tuning/villagers.ts (M2-T03, §7.2; rev 5 adds bedtime … renderRadius, gossipLogLimit)
import type { TuningBank } from '../schema/tuning';
export default {
  wakeFrom: 420, wakeTo: 540, stops: [3, 6], homeFrom: 1200, homeTo: 1380, idleMinutes: [20, 90],
  walkSpeed: 1.6, moveInEveryDays: 2, talkRange: 2, pauseMaxMinutes: 10, noRepeatLines: 12, gossipDays: 7,
  bedtime: 1440, sleepyFromHour: 22, gossipChance: 0.4, memoryChance: 0.3, maxGiftMemories: 10, renderRadius: 28, gossipLogLimit: 50,
  friendship: { chatPerDay: 1, giftBase: 1, giftPerBells: 1000, favCategoryBonus: 3, favColorBonus: 2,
                tiers: [0, 10, 30, 60, 100, 160], milestoneGiftTiers: [2, 4] },
} as const satisfies TuningBank;
